var React = require("react");
var ApplicationContext = require("../../config/ApplicationContext.js");

class Feature extends React.Component {
    componentWillMount(){
		this.linkPackage = ApplicationContext.getPackageEditor();
    }

    render() {
        return (
        	<div>
	            <div className="feature-callout empty">
	             <img className="carousel__container__preview" src={ApplicationContext.assetUrlPrefix + "/assets/home/ipc_generator.gif"}/>	            	
	            	<h2 className="carousel__container__info__title">Create manufacturing-ready footprints & 3D models*</h2>
                    <p>Instantly generate PCB packages by entering a few dimensions from a data sheet.</p>
                        <p className="disclaimer">*Footprint pad geometries are generated to meet IPC-7351B standards.  Always verify components prior to manufacturing.</p>                    
                        <a className="carousel__container__info__create button" href={`${this.linkPackage}?hub=${this.props.idHub}`} target="_blank">Create a package</a>
	            </div>
            </div>
        );
    }
}


module.exports = Feature;
